import { MockedVdd } from '@vi-iot/client/apis/remote-diagnostics/mocked-vdds/MockedVdd.model';
import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '@vi-iot/client';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class HolidayAtHomePhaseCircuitTwo implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 02 04 0C 0C 16 10 02 17 01 01',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.HolidayAtHomePhaseCircuitTwo,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'HolidayAtHomePhaseCircuitTwo',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'STARTDATE',
              path: 'PA_DataRecor/PA_StartDate',
              translationid: 'TI_StartDate',
              dopname: '3 Byte Structure Date',
              name: 'PA_StartDate',
              structure: [
                {
                  semantic: 'DAY',
                  path: 'PA_DataRecor/PA_StartDate/PA_Day',
                  unit: 'd',
                  translationid: 'TI_Day',
                  dopname: '1 Byte Identical uint8 Day',
                  name: 'PA_Day',
                  value: '12',
                },
                {
                  semantic: 'MONTH',
                  path: 'PA_DataRecor/PA_StartDate/PA_Month',
                  unit: 'm',
                  translationid: 'TI_Month',
                  dopname: '1 Byte Identical uint8 Month',
                  name: 'PA_Month',
                  value: '12',
                },
                {
                  semantic: 'YEAR',
                  path: 'PA_DataRecor/PA_StartDate/PA_Year',
                  unit: 'yr',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 Year',
                  name: 'PA_Year',
                  value: '22',
                },
              ],
            },
            {
              semantic: 'ENDDATE',
              path: 'PA_DataRecor/PA_EndDate',
              translationid: 'TI_EndDate',
              dopname: '3 Byte Structure Date',
              name: 'PA_EndDate',
              structure: [
                {
                  semantic: 'DAY',
                  path: 'PA_DataRecor/PA_EndDate/PA_Day',
                  unit: 'd',
                  translationid: 'TI_Day',
                  dopname: '1 Byte Identical uint8 Day',
                  name: 'PA_Day',
                  value: '16',
                },
                {
                  semantic: 'MONTH',
                  path: 'PA_DataRecor/PA_EndDate/PA_Month',
                  unit: 'm',
                  translationid: 'TI_Month',
                  dopname: '1 Byte Identical uint8 Month',
                  name: 'PA_Month',
                  value: '2',
                },
                {
                  semantic: 'YEAR',
                  path: 'PA_DataRecor/PA_EndDate/PA_Year',
                  unit: 'yr',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 Year',
                  name: 'PA_Year',
                  value: '23',
                },
              ],
            },
            {
              semantic: 'BOOLEANCHOICE',
              path: 'PA_DataRecor/PA_Enabl',
              unit: '',
              translationid: 'TI_Enabled',
              dopname: '1 Byte TextTable DisableEnable',
              name: 'PA_Enabl',
              value: 'Enable',
            },
            {
              semantic: 'BOOLEAN',
              path: 'PA_DataRecor/PA_Activ',
              unit: '',
              translationid: 'TI_Active',
              dopname: '1 Byte TextTable InactiveActive',
              name: 'PA_Activ',
              value: 'Active',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 02 04',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.HolidayAtHomePhaseCircuitTwo,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '516',
          value: 'HolidayAtHomePhaseCircuitTwo',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'DEFVALUE',
              longname: 'DefValueEnable',
              byteposition: '0',
              dopname: '1 Byte TextTable DisableEnable',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_DefValueEnabl',
              constraints: '',
              structure: [
                {
                  TI_texttableentry: 'TI_Disable',
                  interval: '0',
                  texttableentry: 'Disable',
                },
                {
                  TI_texttableentry: 'TI_Enable',
                  interval: '1',
                  texttableentry: 'Enable',
                },
              ],
              path: 'PA_Value/PA_DefValueEnabl',
              unit: '',
              translationid: 'TI_DefValueEnable',
              bitposition: '0',
              name: 'PA_DefValueEnabl',
              value: 'Enable',
            },
            {
              semantic: 'DEFVALUE',
              longname: 'DefValueActive',
              byteposition: '1',
              dopname: '1 Byte TextTable InactiveActive',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_DefValueActiv',
              constraints: '',
              structure: [
                {
                  TI_texttableentry: 'TI_Inactive',
                  interval: '0',
                  texttableentry: 'Inactive',
                },
                {
                  TI_texttableentry: 'TI_Active',
                  interval: '1',
                  texttableentry: 'Active',
                },
              ],
              path: 'PA_Value/PA_DefValueActiv',
              unit: '',
              translationid: 'TI_DefValueActive',
              bitposition: '0',
              name: 'PA_DefValueActiv',
              value: 'Inactive',
            },
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '2',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                {
                  TI_texttableentry: 'TI_False',
                  interval: '0',
                  texttableentry: 'False',
                },
                {
                  TI_texttableentry: 'TI_True',
                  interval: '1',
                  texttableentry: 'True',
                },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'True',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0020_HPMU_CAN01',
          request_parameter_value: VddNames.HolidayAtHomePhaseCircuitTwo,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '516',
              value: 'HolidayAtHomePhaseCircuitTwo',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'STARTDATE',
                  longname: 'StartDate',
                  byteposition: '0',
                  dopname: '3 Byte Structure Date',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_StartDate',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'DAY',
                      longname: 'Day',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8 Day',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Day',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_StartDate/PA_Day',
                      unit: 'd',
                      translationid: 'TI_Day',
                      bitposition: '0',
                      name: 'PA_Day',
                      value: '0',
                    },
                    {
                      semantic: 'MONTH',
                      longname: 'Month',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8 Month',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Month',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_StartDate/PA_Month',
                      unit: 'm',
                      translationid: 'TI_Month',
                      bitposition: '0',
                      name: 'PA_Month',
                      value: '0',
                    },
                    {
                      semantic: 'YEAR',
                      longname: 'Year',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8 Year',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Year',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_StartDate/PA_Year',
                      unit: 'yr',
                      translationid: 'TI_Year',
                      bitposition: '0',
                      name: 'PA_Year',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_StartDate',
                  unit: '',
                  translationid: 'TI_StartDate',
                  bitposition: '0',
                  name: 'PA_StartDate',
                  value: '3',
                },
                {
                  semantic: 'ENDDATE',
                  longname: 'EndDate',
                  byteposition: '3',
                  dopname: '3 Byte Structure Date',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_EndDate',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'DAY',
                      longname: 'Day',
                      byteposition: '0',
                      dopname: '1 Byte Identical uint8 Day',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Day',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_EndDate/PA_Day',
                      unit: 'd',
                      translationid: 'TI_Day',
                      bitposition: '0',
                      name: 'PA_Day',
                      value: '0',
                    },
                    {
                      semantic: 'MONTH',
                      longname: 'Month',
                      byteposition: '1',
                      dopname: '1 Byte Identical uint8 Month',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Month',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_EndDate/PA_Month',
                      unit: 'm',
                      translationid: 'TI_Month',
                      bitposition: '0',
                      name: 'PA_Month',
                      value: '0',
                    },
                    {
                      semantic: 'YEAR',
                      longname: 'Year',
                      byteposition: '2',
                      dopname: '1 Byte Identical uint8 Year',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UINT32',
                      shortname: 'PA_Year',
                      constraints: '[0:255]',
                      path: 'PA_Struc/PA_EndDate/PA_Year',
                      unit: 'yr',
                      translationid: 'TI_Year',
                      bitposition: '0',
                      name: 'PA_Year',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_EndDate',
                  unit: '',
                  translationid: 'TI_EndDate',
                  bitposition: '0',
                  name: 'PA_EndDate',
                  value: '3',
                },
                {
                  semantic: 'BOOLEANCHOICE',
                  longname: 'Enabled',
                  byteposition: '6',
                  dopname: '1 Byte TextTable DisableEnable',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_Enabl',
                  constraints: '',
                  structure: [
                    {
                      TI_texttableentry: 'TI_Disable',
                      interval: '0',
                      texttableentry: 'Disable',
                    },
                    { TI_texttableentry: 'TI_Enable', interval: '1', texttableentry: 'Enable' },
                  ],
                  path: 'PA_Struc/PA_Enabl',
                  unit: '',
                  translationid: 'TI_Enabled',
                  bitposition: '0',
                  name: 'PA_Enabl',
                  value: 'Disable',
                },
                {
                  semantic: 'BOOLEAN',
                  longname: 'Active',
                  byteposition: '7',
                  dopname: '1 Byte TextTable InactiveActive',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_Activ',
                  constraints: '',
                  structure: [
                    {
                      TI_texttableentry: 'TI_Inactive',
                      interval: '0',
                      texttableentry: 'Inactive',
                    },
                    { TI_texttableentry: 'TI_Active', interval: '1', texttableentry: 'Active' },
                  ],
                  path: 'PA_Struc/PA_Activ',
                  unit: '',
                  translationid: 'TI_Active',
                  bitposition: '0',
                  name: 'PA_Activ',
                  value: 'Inactive',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
